module.exports = __webpack_public_path__ + "img/16.8da2910e.jpg";